import { publish } from "@infrastructure/Events/EventBus";
import {
    StartActivationEvent,
    USER_ACTIVATION_START,
} from "../Components/UserStateModals/UserStateModals.events";

const eventFactory = (
    successCallback?: () => void,
    cancelCallback?: () => void,
): StartActivationEvent => {
    return {
        name: USER_ACTIVATION_START,
        success: successCallback,
        cancel: cancelCallback,
    };
};

export const startUserActivation = (
    successCallback?: () => void,
    cancelCallback?: () => void,
) => {
    publish(eventFactory(successCallback, cancelCallback));
};
